<template>
  <header class="header">

    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="refresh()">
      {{$t('message.connections.message.update')}}
    </button>

    <LocalFilter data-entity="connections" />
    
    <button class=" mac btn btn-primary btn-extra-round"
            @click="openMacsManagement()">
      Gerenciar MACs
    </button>

    <p class="header-connections">{{ $t('message.connections.message.numberOfConnections') }}: {{  numberOfConnections  }}</p>

    <ConnectionsMacManagementModal></ConnectionsMacManagementModal>
  </header>
</template>

<script>
    import LocalFilter from '@components/filters/LocalFilter'
    import EventBus from '@packages/event-bus/index'
    import ConnectionsMacManagementModal from './mac-management-modal/ConnectionsMacManagementModal'
    

    export default {
        components: {
            LocalFilter,
            ConnectionsMacManagementModal,
        },

        data() {
            return {
                tab: null,

                tabs: [
                    {
                        label: this.$t('message.connections.message.connected'),
                        value: 'CONNECTED'
                    },

                    {
                        label: this.$t('message.connections.message.unknown'),
                        value: 'UNKNOWN'
                    }
                ]
            }
        },

        computed:{
          numberOfConnections (){
            return this.$store.state['connections'].count
          }
        },

        watch: {
            tab(tab) {
                const isUnknown = tab === 'UNKNOWN'
                this.$store.commit('CONNECTIONS_SET_FILTER', {
                    key: 'unknown',
                    value: isUnknown
                })
                EventBus.$emit('load-connections')
            }
        },
        methods:{
            refresh(){
                EventBus.$emit('load-connections')
            },
            openMacsManagement(){
                EventBus.$emit('EDIT_MACS')
            },
        }
    }
</script>
<style lang="scss" scoped>
header.header {
  position: relative;
  display: flex;
  align-items: center;

  .search-wrapper {
    position: absolute;
    right: 50px;
    max-width: 300px;
  }

  .tab-selector-wrapper {
    width: 400px;
    margin-right: auto;
  }
  .btn-primary {
    margin-right: 20px;
    width: 150px;
  }

  .mac {
    margin-left: 20px;
    width: fit-content;
  }

  .header-connections {
    margin: 0 50px 0 auto;
    font-weight: 600;
  }
}
</style>
